'use strict';

var URLREG = /(\w+):\/\/\/?/i;

var protocol = module.exports = function () {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var result = URLREG.exec(url);
    var defaultProtocol = location && location.protocol || 'https';
    var _url = '';
    if (result && result[0]) {
        _url = url;
    } else if (/^(\/){2}/.test(url)) {
        _url = defaultProtocol + url;
    } else {
        _url = defaultProtocol + '//' + url;
    }
    return _url;
};


//////////////////
// WEBPACK FOOTER
// ../src/util/protocol.js
// module id = 17
// module chunks = 0 2 4